<template>
  <div class="mx-2">
    <template v-for="(item, id) in Object.values(detail.pelapors || {})">
      <v-row v-if="Object.keys($getDeepObj(item, 'psp_profil_pa.data.ptk') || {}).length" :key="id">
        <v-col v-if="id !== 0" cols="12" class="py-0">
          <v-divider class="mt-2" />
        </v-col>
        <v-col cols="12" lg="4">
          <v-list-item class="px-0">
            <v-list-item-avatar color="blue">
              <v-icon dark>mdi-account</v-icon>
            </v-list-item-avatar>
            <v-list-item-content class="py-0 px-1">
              <div class="caption grey--text mb-0">Nama Fasilitator</div>
              <div class="black--text body-2">
                {{ $getDeepObj(item, 'psp_profil_pa.data.ptk.data.nama') || '-' }}
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" lg="4">
          <v-list-item class="px-0">
            <v-list-item-content class="py-0">
              <div class="caption grey--text mb-0">SIMPKB ID</div>
              <div class="black--text body-2">
                {{ $getDeepObj(item, 'psp_profil_pa.data.ptk_id') }}
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
export default {
  name: 'DetailPendampinganFasilitator',
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style scoped></style>
